export const formatDeliveryCost = (rawDeliveryCost?: unknown): number | null => {
	if (rawDeliveryCost === null) return null;

	const normalizedDeliveryCost = Number(rawDeliveryCost);
	return Number.isNaN(normalizedDeliveryCost) ? null : normalizedDeliveryCost;
};
